import React, { useEffect, useMemo, useRef } from "react";
import "../sass/layout/_contactUs.scss";
import "../sass/base/_base.scss";
import { Banner } from "../components/banner.js";
import useWindowDimensions from "../hooks/useWindowDimensions.js";
import contactImage from "../static/images/contactUs/contactUs.jpg";
import { Image } from "../components/Image.js";
import instaIcon from "../static/images/icons/instagram.svg";
import linkedIcon from "../static/images/icons/linkedIn.svg";
import { BookNow } from "../components/BookNow.js";
import { useLocation } from "react-router-dom";

export const ContactUs = () => {
  const location = useLocation();
  const bookNowRef = useRef(null);

  const country = useMemo(
    () => (location.state ? location.state.country : ""),
    [location.state]
  );
  const destination = useMemo(
    () => (location.state ? location.state.destination : ""),
    [location.state]
  );


  const { width } = useWindowDimensions();
  const [fontSize, setFontSize] = React.useState({
    bannerTop: "8rem",
    bannerBottom: "2rem",
  });

  useEffect(() => {
    if (width > 900 && width <= 1200) {
      setFontSize({
        bannerTop: "6rem",
        bannerBottom: "1.8rem",
      });
      return;
    } else if (width > 600 && width <= 900) {
      setFontSize({
        bannerTop: "5rem",
        bannerBottom: "1.6rem",
      });
      return;
    } else if (width <= 600) {
      setFontSize({
        bannerTop: "4rem",
        bannerBottom: "1.3rem",
      });
      return;
    }

    return setFontSize({
      bannerTop: "8rem",
      bannerBottom: "1.8rem",
    });
  }, [width]);

  useEffect(() => {
    if (location.state && bookNowRef.current) {
      bookNowRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.state]);


  return (
    <>
      <>
        <h1 className="cu-heading" style={{ letterSpacing: "normal" }}>
          Contact Us
        </h1>
        <div className="cu-container-part-1">

          <div
            className="cu-container-part-1-map-container"
            style={{
              backgroundImage: `url(${contactImage})`,
              backgroundPosition: 'center',
            }}
          />


          <div className="cu-container-part-1-details">
            <p>
              We're here to assist you with any inquiries or travel
              bookings. Whether you're seeking information on our
              extraordinary destinations, planning your dream journey, or
              simply looking for guidance, our team is ready to help.
            </p>

            <div style={{
              display: "flex",
              flexDirection: "column",
              height: "100%"
            }}>
              <h1>How to reach us</h1>
              <ul>

                <li>
                  <b>Email:</b>
                  <br />
                  info@wanderluxe.sg
                </li>
                <li>
                  <b>Form:</b> <br />
                  Please fill in your queries and details below, and we'll get back to you as soon as possible
                </li>
                <li>
                  <b>Follow Us:</b>
                  <br />
                  Stay updated with our latest news, offers, and travel
                  inspiration by following us on
                  social media platforms.
                </li>
              </ul>
              <div className="footer-section-links" style={{ display: "flex", flexDirection: "row" }}>
                <a href="https://www.instagram.com/wanderluxe_sg/profilecard/?igsh=a21ldXNvd20yZzk3">
                  <Image src={instaIcon} height={25} width={25} color="rgba(20, 20, 20)" />
                </a>
                <a href="https://www.linkedin.com/company/wanderluxe-sg/">
                  <Image alt="linkedIn" src={linkedIcon} height={25} width={25} color="rgba(20, 20, 20)" />
                </a>
              </div>

            </div>
          </div>
        </div>
      </>
      <Banner
        width={width > 600 ? "75%" : "100%"}
        renderIcons={false}
        style={{
          padding: width > 600 && "2rem",
          height: width < 600 && "22vh"
        }}
        fontSize={fontSize.bannerBottom}
        textTransform={"initial"}
        headingStyle={{
          marginBottom: width < 600 && 0,
          padding: width < 600 && "1rem"
        }}
        heading={
          <>
            Your travel dreams are just a message or a call away. {width > 600 && <br />} We look forward to helping you make your journey extraordinary.
          </>
        }
        backgroundColor={"#97789b"}
      />
      <div ref={bookNowRef}>
        <BookNow country={country} destination={destination} />
      </div>
    </>
  );
};
